<ng-container *renderIf="item.role">
  <ng-container *ngIf="!item.hidden">
    <!-- collapsible title -->
    <a class="d-flex align-items-center justify-content-center" [ngClass]="item.classes" [ngClass]="
        item.type == 'section'
          ? 'dropdown-toggle nav-link'
          : 'dropdown-item dropdown-toggle'
      " *ngIf="!item.url">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>

    <!-- itemContent template -->
    <ng-template #itemContent>
      <img [src]="'assets/images/icons/home/'+item.icon" alt="" width="28" height="28">
    </ng-template>

    <!-- sub-menu item/collapsible -->
    <ul class="dropdown-menu" [ngClass]="{ show: isShow }">
      <h6 class="dropdown-header">{{item.title}}</h6>
      <ng-container *ngFor="let item of item.children">
        <!-- item -->
        <ng-container *renderIf="item.role">
          <li core-menu-horizontal-item *ngIf="item.type == 'item'" [item]="item" [child]="true"
            [ngClass]="{ disabled: item.disabled === true }" [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
            [routerLinkActiveOptions]="{ exact: item.exactMatch || false }">
            <span [routerLink]="item.openInNewTab ? [] : [item.url]" class="d-none"></span>
          </li>
          <!-- collapsible -->
          <li core-menu-horizontal-collapsible *ngIf="item.type == 'collapsible'" [item]="item"
            class="dropdown dropdown-submenu"></li>
        </ng-container>
      </ng-container>
    </ul>
  </ng-container>
</ng-container>